import { render, staticRenderFns } from "./lockElement.vue?vue&type=template&id=61b3a430&scoped=true&"
import script from "./lockElement.vue?vue&type=script&lang=js&"
export * from "./lockElement.vue?vue&type=script&lang=js&"
import style0 from "./lockElement.vue?vue&type=style&index=0&id=61b3a430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b3a430",
  null
  
)

export default component.exports